import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import ProductCard from "@/components/ProductCard";

export default function RelatedProducts({ productId, category }) {
  const [items, setItems] = useState([]);

  useEffect(() => {
    if (!productId) return;
    api.get(`/products/${productId}/related?limit=6`).then((r) => setItems(r.data || [])).catch(() => setItems([]));
  }, [productId]);

  if (!items.length) return null;

  return (
    <section className="mt-10 border-t border-[#E7E5E4] pt-8" data-testid="related-products">
      <div className="flex items-end justify-between mb-4">
        <div>
          <div className="text-xs uppercase tracking-[0.2em] text-[#7C1F30] mb-1">You may also like</div>
          <h2 className="font-serif text-xl sm:text-2xl text-[#173A3A]">{items.some((item) => item.category !== category) ? "More to explore" : `More from ${category || "this collection"}`}</h2>
        </div>
      </div>
      <div className="grid grid-cols-2 gap-x-2 gap-y-4 sm:gap-x-3 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5">
        {items.slice(0, 5).map((p) => <ProductCard key={p.id} product={p} />)}
      </div>
    </section>
  );
}
